import { render } from "./PageFooter.vue?vue&type=template&id=0a24412b&scoped=true&ts=true"
import script from "./PageFooter.vue?vue&type=script&lang=ts"
export * from "./PageFooter.vue?vue&type=script&lang=ts"

import "./PageFooter.vue?vue&type=style&index=0&id=0a24412b&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/wanfei-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a24412b"]])

export default __exports__